<template>
	<div class="basis-page-cls" v-loading="loading">
		<section class="basis-cls_filter" v-if="userInfo.userType == '1'">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
		<section class="basis-cls_table">
			<div class="header">
				<span class="title el-icon-document"> 群组列表</span>
				<div class="btns">
					<el-button type="primary" icon="el-icon-plus" size="small" @click="handleCreate">新增群组</el-button>
				</div>
			</div>
			<div class="table">
				<table-pagination
					ref="expandTable"
					lazy
					pagination
					row-key="groupId"
					:data="list"
					:column="column"
					:total="total"
					:page.sync="listQuery.pageNum"
					:limit.sync="listQuery.pageSize"
					:tree-props="{children: 'groupList',hasChildren:'hasChildren'}"
                    :load="load"
					@pagination="getList" />
			</div>
		</section>

		<el-dialog :title="`${dialogStatus}群组`" :modal-append-to-body="false" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" :close-on-press-escape="false">
			<el-form :model="groupForm" ref="groupForm" autocomplete="off" label-width="90px">
				<el-form-item label="群组：" prop="groupName" :rules="[
					{required: true, trigger: 'blur', message: '请输入群组名称'}
				]">
					<el-input v-model="groupForm.groupName" placeholder="请输入群组名称" maxlength="25" show-word-limit autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="群组管理员：" prop="groupManagerUserIds">
					<!-- <el-select remote :remote-method="remoteMethod" @focus="getManageSelec" multiple v-model="groupForm.groupManagerUserIds" placeholder="请选择群组管理员" filterable clearable  style="width: 100%">
						<el-option v-for="(item,index) in account_options" :key="index" :label="item.nickname" :value="item.userId"></el-option>
					</el-select>
					{{ relationList }} -->
					<el-select ref="selectDom" v-model="groupForm.groupManagerUserIds" :remote-method="remoteMethod1" placeholder="请选择群组管理员" clearable filterable multiple remote @visible-change="templateTagChange" style="width: 100%">
						<el-option
							v-for="item in relationList"
							:key="item.userId"
							:label="item.nickname"
							:value="item.userId"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="备注：" prop="description">
					<el-input v-model="groupForm.description" :autosize="{ minRows: 2}"  placeholder="请输入备注" maxlength="30" show-word-limit type="textarea"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button @click.stop="create" v-if="['新增', '新增子'].includes(dialogStatus)" size="small" type="primary" :loading="loading">确 定</el-button>
				<el-button @click.stop="update" v-else size="small" type="primary" :loading="loading">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="群组成员" :modal-append-to-body="false" :visible.sync="dialogGroupVisible" width="625px" :close-on-click-modal="false" :close-on-press-escape="false">
			<el-transfer
				v-if="dialogGroupVisible"
				v-model="userForm.userIdList"
				filter-placeholder="请搜索用户"
				filterable
				:titles="['可选用户', '群组内']"
				:filter-method="filterMethod"
				:props="{key: 'userId', label: 'nickname'}"
				:data="userData">
			</el-transfer>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogGroupVisible = false">取 消</el-button>
				<el-button @click.stop="updateGroup" size="small" type="primary" :loading="loading">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
		computed: {
            ...mapGetters([
                'userInfo'
            ])
        },
        data() {
            return {
				form: {
					diagnosisIds: []
				},
				relationList: [],
				loading: false,
				filterHeader: [
					{ label: '品牌标识', model: 'brandIdentify', type: 'input', default: '', placeholder: "请输入品牌标识"},
					{ label: '品牌名称', model: 'brandName', type: 'input', default: '', placeholder: "请输入品牌名称"}
				],
                column: [
					{
                        label: '群组',
                        minWidth: 120,
                        render: (h, scope) => {
                            return (
                                <span>
                                {
                                    !scope.row.hasChildren &&
                                    <div class="indents" style={{
                                        display: "inline-block",
                                        width: "20px",
                                        height: "20px",
                                        marginRight: "3px",
                                    }}></div>
                                }
								{scope.row.groupName}
                                </span>
                            )
                        }
                    }, 
					{ label: '群组管理员', prop: 'groupManagerUserNicknames' },
                    { label: '备注', prop: 'description' },
                    { label: '创建时间', prop: 'createTime' },
                    {
                        label: '操作',
                        prop: 'cation',
                        align: 'center',
                        width: 240,
                        fixed: 'right',
                        render: (h, scope) => {
                            return (
                                <div>
                                    <el-button 
                                        onClick={() => this.handleGroup(scope.row)}
                                        type="text">
                                        群组成员
                                    </el-button>
                                    <el-button 
                                        onClick={() => this.handleCreate(scope.row)}
                                        type="text" icon="el-icon-plus">
                                        子群组
                                    </el-button>
                                    <el-button 
                                        onClick={() => this.handleUpdate(scope.row)}
                                        type="text">
                                        修改
                                    </el-button>
									<el-button 
                                        onClick={() => this.handleDelete(scope.row)}
                                        type="text">
                                        删除
                                    </el-button>
                                </div>
                            )
                        }
                    }
                ],
                listQuery: {
                    pageNum: 1,
                    pageSize: 10,
					orderBy: 'create_time desc',
					data: {
						parentGroupId: '',
						brandIdentify: '',
						brandName: ''
					}
                },
                total: 0,
                list: [],
				dialogVisible: false,
				dialogStatus: '',
				groupForm: {
					groupName: '',
					description: '',
					parentGroupId: '',
					groupManagerUserIds: ''
				},
				dialogGroupVisible: false,
				userData: [],
				userForm: {
					groupId: '',
					userIdList: [],
					groupManagerUserIds:[]
				},
				account_options:[]
            }
        },
		async created() {
			await this.getList();
			await this.getManageSelec()
		},
        methods: {
			// 远程搜索方法，数据太多，不能直接渲染
			remoteMethod1(query) {
				if (query !== '') {
					this.relationList = []
					this.loading = true
					// 这个方法可以做下节流处理，不需要一输入就发起请求，这里偷懒没有写
			
						this.$api.getManageSel({
						data: {
							roleList: null,
							account: null,
							agentCode: null,
							createTimeFrom: null,
							createTimeTo:null,
							nickname: query,
							userType: '',
							brandIdentify: this.userInfo.brandIdentify,
							brandList: null,
						},
						orderBy: null,
						pageNum: 1,
						pageSize: 100
					}).then(res => {
					if(res.errcode != 0) return;
					this.loading = false
						this.relationList = res.list.filter(item => {
							return item.nickname.toLowerCase()
							.indexOf(query.toLowerCase()) > -1
						})
					// this.account_options = res.list;
				});
				} else {
					this.relationList = []
				}
				},
				// 诊断选择器下拉框隐藏时触发事件，清空数据
				templateTagChange(val) {
				if (val === false) {
					this.relationList = []
				}
			},
			remoteMethod(query) {
				if(!query) return;
				this.$api.getManageSel({
						data: {
							roleList: null,
							account: null,
							agentCode: null,
							createTimeFrom: null,
							createTimeTo:null,
							nickname: query,
							userType: '',
							brandIdentify: this.userInfo.brandIdentify,
							brandList: null,
						},
						orderBy: null,
						pageNum: 1,
						pageSize: 100
					}).then(response => {
					if(response.errcode != 0) return;
					this.account_options = response.list;
				});
			},
			getManageSelec() {
				this.$api.getManageSel({
					data: {
						roleList: null,
						account: null,
						agentCode: null,
						createTimeFrom: null,
						createTimeTo:null,
						nickname: null,
						userType: '',
						brandIdentify: this.userInfo.brandIdentify,
						brandList: null,
					},
					orderBy: null,
					pageNum: 1,
					pageSize: 100
				}).then(res => {
					this.relationList = res.list;
				}).catch(() => {
				})
			},
			refreshTree(){
				const tableRef = this.$refs.expandTable.$refs.elTable;
				let obj = tableRef['store'].states.treeData;
				for(let key in obj){
					tableRef['store'].states.treeData[key].loaded = false;
					tableRef['store'].states.treeData[key].expanded = false;
				}
				this.$set(this.$refs.expandTable.$refs.elTable.store.states, 'lazyTreeNodeMap', {})
			},
			getList() {
				this.loading = true;
				this.$api.apiPostGroupSelectList(this.listQuery).then(response => {
					if(response.errcode != 0) {
						this.loading = false;
						return;
					}
					this.list = response.list;
                    this.list.forEach(val => {
						val.hasChildren = val.subGroupCount > 0;
                    });
					this.total = response.total;
					this.loading = false;
					this.refreshTree();
				}).catch(error => {
					this.loading = false;
				});
			},
			load(row, treeNode, resolve) {
				this.loading = true;
				this.$api.apiPostGroupSelectList({
					pageNum: 1,
                    pageSize: 100,
					orderBy: 'create_time desc',
					data: {
						parentGroupId: row.groupId
					}
				}).then(response => {
					if(response.errcode != 0) {
						this.loading = false;
						return;
					}
					if (response.list.length <= 0) {
						resolve([]);
						this.$message.error('没有子部门，请先新增');
						this.loading = false;
						return;
					}
                    response.list.forEach(val => {
						val.hasChildren = val.subGroupCount > 0;
                    });
					resolve(response.list);
					this.loading = false;
				}).catch(error => {
					this.loading = false;
				});
			},
			handleCreate(row) {
				this.resetForm();
				this.groupForm.parentGroupId = row.groupId;
				this.dialogVisible = true;
				console.log(row)
				this.dialogStatus = row.parentGroupId === null ? '新增子' : '新增';
			},
			handleUpdate(row){
				this.resetForm();
				this.groupForm = Object.assign(this.groupForm, row);
				this.groupForm.groupManagerUserIds = row.groupManagerUserIds ? row.groupManagerUserIds.split(',') : [];
				this.dialogVisible = true;
				this.dialogStatus = row.parentGroupId ? '修改子' : '修改';
			},
			handleDelete(row) {
				this.$confirm(`您将删除 ${row.groupName} 群组，删除后该群组成员解散，请确认`, '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true;
					this.$api.apiGetGroupSelectDelete(row.groupId).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						}
						
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.getList();
					}).catch(error => {
						this.loading = false;
					});
				}).catch(() => {});
			},
			handleGroup(row) {
				this.loading = true;
				this.$api.apiPostGroupGetUserList({groupId: row.groupId}).then(response => {
					console.log(response);
					if(response.errcode != 0) {
						this.loading = false;
						return;
					}
					this.userData = response.data.userList;
					this.userForm.groupId = row.groupId;
					this.userForm.userIdList = response.data.userListSelected;
					this.dialogGroupVisible = true;
					this.loading = false;
				}).catch(error => {
					this.loading = false;
				});
			},
			create() {
				this.$refs["groupForm"].validate(valid => {
					if (valid) {
						this.loading = true;
						this.$api.apiPostGroupSelectAdd(this.groupForm).then(response => {
							if(response.errcode != 0) {
								this.loading = false;
								return;
							}
							this.$notify({
								title: "新增成功",
								type: "success"
							});
							this.dialogVisible = false;
							this.getList();
						}).catch(error => {
							this.loading = false;
						});
					}
				});
			},
			update() {
				this.$refs["groupForm"].validate(valid => {
					if (valid) {
						this.loading = true;
						this.$api.apiPostGroupSelectEdit(this.groupForm).then(response => {
							if(response.errcode != 0) {
								this.loading = false;
								return;
							}
							this.$notify({
								title: "修改成功",
								type: "success"
							});
							this.dialogVisible = false;
							this.getList();
						}).catch(error => {
							this.loading = false;
						});
					}
				});
			},
			updateGroup() {
				this.loading = true;
				this.$api.apiPostGroupUpdateUserList(this.userForm).then(response => {
					if(response.errcode != 0) {
						this.loading = false;
						return;
					}
					this.$notify({
						title: "提交成功",
						type: "success"
					});
					this.dialogGroupVisible = false;
					this.loading = false;
				}).catch(error => {
					this.loading = false;
				});
			},
			resetForm() {
				this.groupForm = {
					groupName: '',
					description: '',
					parentGroupId: '',
					groupManagerUserIds: ''
				};
				if (this.$refs["groupForm"]) {
					this.$refs["groupForm"].resetFields();
					this.$refs["groupForm"].clearValidate();
				}
			},
			filterMethod(query, item) {
				return item.nickname.indexOf(query) > -1;
			},
			filterSearch(query){
				this.listQuery = Object.assign(this.listQuery, query);
				this.listQuery.data = Object.assign(this.listQuery?.data, {brandIdentify: query.brandIdentify, brandName: query.brandName});
				delete this.listQuery.brandIdentify;
				delete this.listQuery.brandName;
				this.getList();
			},
        },
    }
</script>
